// Window focus also fires when moving out of a payment iframe. Only refresh
// after the document actually lost focus or became hidden, not between fields.
export function onDocumentReturn(refresh) {
  let away = document.visibilityState === 'hidden';
  const onBlur = () => {
    if (!document.hasFocus()) away = true;
  };
  const onReturn = () => {
    if (!away || document.visibilityState === 'hidden') return;
    away = false;
    refresh();
  };
  const onVisibility = () => {
    if (document.visibilityState === 'hidden') away = true;
    else onReturn();
  };
  window.addEventListener('blur', onBlur);
  window.addEventListener('focus', onReturn);
  document.addEventListener('visibilitychange', onVisibility);
  return () => {
    window.removeEventListener('blur', onBlur);
    window.removeEventListener('focus', onReturn);
    document.removeEventListener('visibilitychange', onVisibility);
  };
}
